module.exports = __webpack_public_path__ + "img/IMG_20190831_145931.5b2ebe78.jpg";